import { AppSettings } from '../app-settings';
import { SelectListItemModel } from './select-list-item.model';
import { SummerAppFieldTypesEnum } from '../enums/field-types.enum';
import { QuestionBaseModel } from "./question-base.model";

export class YesNoSelectorQuestionModel extends QuestionBaseModel<string> {

    fieldTypeName = SummerAppFieldTypesEnum.YesNoSelector;
    options: SelectListItemModel[] = [
        {name:"Yes",value:"1",description:null},
        {name:"No",value:"0", description:null}  
    ];

    constructor(options: {} = {}) {
      super(options);
    }
  }


// WEBPACK FOOTER //
// ./src/app/shared/models/yes-no-selector-question.model.ts